import type { VariantPickerModel } from 'autogen/swagger/all';
import useMediatorState, { mediatorAtom } from 'hooks/globals/useMediatorAtom';

export const VariantPickerQuickViewState = mediatorAtom<{
    isOpen: boolean;
    variantPickerModel?: VariantPickerModel;
    isPDPRequest?: boolean;
}>({ isOpen: false, isPDPRequest: false });

export default function useVariantPickerQuickView() {
    return useMediatorState(VariantPickerQuickViewState);
}
